import type { ReactNode } from "react";
import { BrandShell } from "@/templates/BrandShell";

interface AuthLayoutProps {
  /** Heading shown above the form. */
  title: string;
  /** Sentence beneath the heading. */
  subtitle?: ReactNode;
  /** Form contents. */
  children: ReactNode;
  /** Optional footer line beneath the form. */
  footer?: ReactNode;
}

/**
 * Auth shell — centred 360px form column over the shared BrandShell
 * background.
 */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <BrandShell>
      <div className="w-full max-w-[360px]">
        <div className="mb-16 text-center">
          <h1 className="text-4xl font-semibold tracking-tight text-fg sm:text-5xl" style={{ lineHeight: 1.1 }}>
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-sm leading-relaxed text-fg-muted">{subtitle}</p>
          )}
        </div>
        {children}
        {footer && (
          <div className="mt-8 text-center text-sm text-fg-muted">{footer}</div>
        )}
      </div>
    </BrandShell>
  );
}
